import { makeStyles } from 'tss-react/mui'
import { darkBackgroundSecondaryTextColor } from '../../../theme/theme'

export const useStyles = makeStyles<void, string>()((theme, props, classes) => ({
    parentContainer: {
        padding: theme.spacing(1, 2),
        cursor: 'pointer',
        '&:hover': {
            [`& .${classes.displayOnHover}`]: {
                opacity: 1,
                pointerEvents: 'unset',
                zIndex: 1

            },
            [`& .${classes.hoveredButtons}`]: {
                display: 'flex'

            },
            backgroundColor: theme.palette.background.default
        },
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'flex-start',
        justifyContent: 'center',
        gap: theme.spacing(0.5),
        borderWidth: theme.spacing(0.25),
        borderStyle: 'solid',
        borderColor: 'transparent'
    },
    iconHover: {
        fontSize: 14,
        marginLeft: theme.spacing(1),
        '&:hover': {
            color: 'inherit'
        }
    },
    hoveredButton: {
        padding: theme.spacing(0.5),
        width: 22,
        height: 22
    },
    displayOnHover: {
        opacity: 0,
        pointerEvents: 'none',
        zIndex: 1

    },
    avatar: {
        width: 20,
        height: 20
    },
    alertName: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: '14px',
        fontWeight: 700,
        fontStyle: 'normal',
        lineHeight: '21px',
        minWidth: 0
    },
    alertMessage: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: '14px',
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '18px',
        minWidth: 0
    },
    dot: {
        fontSize: '14px',
        verticalAlign: 'middle'
    },
    hoveredIcon: {
        width: 18,
        height: 18
    },
    tooltip: {
        padding: theme.spacing(1)
    },
    wrapOverflow: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        overflow: 'hidden'
    },
    fullWidth: {
        width: '100%'
    },
    hideOverflow: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    primaryBordered: {
        borderColor: theme.palette.primary.main
    },
    fullHeight: {
        height: '100%'
    },
    minW0: {
        minWidth: 0
    },
    verticalAlignMiddle: {
        verticalAlign: 'middle'
    },
    hoveredButtons: {
        justifyContent: 'space-between',
        minWidth: '30%',
        display: 'none',
        alignItems: 'center',
        flex: '1 1 0%',
        flexDirection: 'row'

    },
    cursorPointer: {
        cursor: 'pointer'
    },
    attributes: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        maxWidth: '100%'
    },
    alignCenter: {
        alignItems: 'center'
    },
    tooltipCaption: {
        color: theme.palette.mode === 'light' ? darkBackgroundSecondaryTextColor : theme.palette.text.secondary
    },
    h22: {
        height: '22px'
    }
}))